unit InstrumentType;

interface

uses
  CategoryType, ProductType, UserType;

type
  TInstrumentType = class
  private
    fInstrumentKey: String;
    fProduct: TProductType;
    fCategory: TCategoryType;
    fCreationDate: String;
    fCreatedBy: TUserType;
    fChangedDate: String;
    fChangedBy: TUserType;
    fActive: Boolean;
  public
    property InstrumentKey: String read fInstrumentKey;
    property Product: TProductType read fProduct;
    property Category: TCategoryType read fCategory;
    property CreationDate: String read fCreationDate;
    property CreatedBy: TUserType read fCreatedBy;
    property ChangedDate: String read fChangedDate;
    property ChangedBy: TUserType read fChangedBy;
    property Active: Boolean read fActive;
  end;

implementation

end.
